function t(...n) {
  return (...c) => {
    n.forEach((o) => typeof o == "function" ? o(...c) : void 0);
  };
}
export {
  t as c
};
//# sourceMappingURL=combine-function-calls-C5qD-ZYI.mjs.map
